export default function (doc) {

  let documento = {}

  documento.documentoId = doc ? doc.documentoId : null
  documento.tipoDocumento = doc ? doc.tipoDocumento : { tipoDocumentoId: null, nome: "" }
  documento.numero = doc ? doc.numero : ""
  documento.ano = doc ? doc.ano : ""
  documento.ementa = doc ? doc.ementa : ""
  documento.arquivo = doc ? doc.arquivo : ""
  documento.html = doc ? doc.html : ""
  documento.htmlOriginal = doc ? doc.htmlOriginal : ""
  documento.tags = doc ? doc.tags : []
  documento.destino = doc ? doc.destino : ""
  documento.status = doc ? doc.status : ""
  documento.usuarioId = doc ? doc.usuarioId : null
  documento.diarioId = doc ? doc.diarioId : null

  documento.htmlCompilado = compilar()

  function compilar() {
    if (documento.html != null) {
      const tagInicio = '<s>';
      const tagFim = '</s>';
      const tagEspaco = '<p>&nbsp;</p>'
      const tagEspaco2 = '<p></p>'
      const tagEspaco3 = '&nbsp;'
      let novoHtml = documento.html;
      let index = novoHtml.indexOf(tagInicio);

      while (index != -1) { //retirar rachurado
        const indexOfInicio = novoHtml.indexOf(tagInicio);
        const indexOfFim = novoHtml.indexOf(tagFim) + 4; //+4 para pegar tbm a tag </s>

        const retirado = novoHtml.slice(indexOfInicio, indexOfFim);
        novoHtml = novoHtml.replace(retirado, "");
        index = novoHtml.indexOf(tagInicio);
      }
      index = 0;
      while (index != -1) {//retirar quebra de linha
        index = novoHtml.indexOf(tagEspaco);
        novoHtml = novoHtml.replace(tagEspaco, "");
        index = novoHtml.indexOf(tagEspaco);
      }
      index = 0;
      while (index != -1) {//retirar quebra de linha2
        index = novoHtml.indexOf(tagEspaco2);
        novoHtml = novoHtml.replace(tagEspaco2, "");
        index = novoHtml.indexOf(tagEspaco2);
      }
      index = 0;
      while (index != -1) {//retirar quebra de linha2
        index = novoHtml.indexOf(tagEspaco3);
        novoHtml = novoHtml.replace(tagEspaco3, "");
        index = novoHtml.indexOf(tagEspaco3);
      }
      const tagItalic = '<i></i>'
      const tagTd = '<td></td>'

      index = 0;
      while (index != -1) {//retirar tabela vazia
        index = novoHtml.indexOf(tagItalic);
        novoHtml = novoHtml.replace(tagItalic, "");
        index = novoHtml.indexOf(tagItalic);
      }

      index = 0;
      while (index != -1) {//retirar tabela vazia
        index = novoHtml.indexOf(tagTd);
        novoHtml = novoHtml.replace(tagTd, "");
        index = novoHtml.indexOf(tagTd);
      }
      
      return novoHtml;

    } else {
      return "ERRO AO COMPILAR";
    }
  }

  return documento


}